// Per-field CSS class builder extracted verbatim from the `fieldClass` method of
// components/defaultLayout/EntityDialog&Forms/EntityMaskForm.vue. Pulled into a
// pure module so the type -> spacing mapping (plus the class / highlight /
// view-only appends) is unit-tested and survives the Nuxt 2 -> Nuxt 3
// migration; the component now forwards to this. `isViewMode` (read off `this`
// in the original) is passed in.

import type { TEntityMaskItem } from '~/types/models'

export function getFieldClass(
  ifield: TEntityMaskItem,
  isViewMode: boolean
): string {
  let theClassString = ''
  switch (ifield.type) {
    case 'subtitle': {
      theClassString = 'text-h6 text-primary font-weight-light pl-0 mb-n6'
      break
    }
    case 'textField':
    case 'textArea':
    case 'numberTextField':
    case 'currencyTextField':
    case 'percentageTextField':
    case 'dateTextField':
    case 'dateTimeDisplayDateOnlyTextField':
    case 'dateTimeDisplayTimeOnlyTextField':
    case 'phoneNumberTextField':
    case 'dateField':
    case 'timeField':
    case 'autocomplete':
    case 'combobox':
    case 'fileSelect': {
      theClassString = 'mt-6 mb-n6'
      break
    }
    // `mb-n6` pulls the next field up over this one's details row, which is
    // fine while that row is empty. A persistent hint lives in it, so keep most
    // of the row or the hint sits on the next field's label.
    case 'select': {
      theClassString = ifield.persistentHint ? 'mt-6 mb-n2' : 'mt-6 mb-n6'
      break
    }
    case 'optionsChooser': {
      theClassString = 'mt-6'
      break
    }
    case 'checkbox': {
      theClassString = 'mt-10 mb-n6'
      break
    }
    case 'slider': {
      theClassString = 'mt-13 mb-n11'
      break
    }
    case 'divider': {
      theClassString = 'mt-10 mb-n1'
      break
    }
    default: {
      throw new Error(`Untrapped ifield switch option: ${ifield.type}`)
    }
  }
  theClassString = ifield.class
    ? theClassString + ' ' + ifield.class
    : theClassString
  theClassString = ifield.highlight
    ? theClassString + ' ' + 'font-weight-bold'
    : theClassString

  theClassString = isViewMode
    ? theClassString + ' ' + 'view-only-mode'
    : theClassString

  return theClassString
}
